import { RouteObject } from 'react-router-dom'

// layouts
import { AdminLayout } from '@/layouts/AdminLayout'

// routes
import masterRoute from './master.routes'
import dashboardRoute from './dashboard.routes'
import myTaskRoute from './mytask.routes'
import myRequestRoutes from './myrequest.routes'

// pages
import { NotFound } from '@/pages/others/NotFound'
import { Home } from '@/pages/others/Home'
import { Notification } from '@/pages/notification/Notification'
import { ProtectedRoute } from '@/components/shared/gate/ProtectedRoute'
import GroupTaskPage from '@/pages/group-task/GroupTaskPage'

export const routes: RouteObject[] = [
  {
    path: '/',
    element: <ProtectedRoute layout={AdminLayout} />,
    children: [
      { index: true, element: <Home /> },
      {
        path: '/group-task',
        element: <GroupTaskPage />,
      },
      ...masterRoute,
      ...dashboardRoute,
      ...myTaskRoute,
      ...myRequestRoutes,
      {
        path: '/notifications',
        element: <Notification />,
      },
    ],
  },

  {
    path: '*',
    element: <AdminLayout />,
    children: [{ path: '*', element: <NotFound /> }],
  },
]
